import FormSubmissionEvent from '../datalayer/events/form-submission-event';
import DataLayerUser from '../datalayer/classes/datalayer-user';
import DataLayerUserName from '../datalayer/classes/datalayer-user-name';
import DataLayerUserLocation from '../datalayer/classes/datalayer-user-location';
import applyValidationMessages from '../utility/validation-messages';
import FileDownloadEvent from "../datalayer/events/file-download-event";

let form = null;
let downloadBrochureLink = null;

export default {
    canInit: (selector) => {
        form = document.querySelector(selector);
        return form !== null;
    },
    init: () => {
        form.noValidate = true;
        form.addEventListener('submit', submitHandler);
        
        downloadBrochureLink = field('download-brochure')
        
        if (downloadBrochureLink) {
            downloadBrochureLink.addEventListener('click', downloadBrochure);
        }
    }
};

function submitHandler(e) {
    e.preventDefault();

    applyValidationMessages(form);
    const isValid = form.reportValidity();

    pushDataLayer();

    if (!isValid) {

        const firstInvalid = form.querySelector(':invalid');

        if (firstInvalid) {
            firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
            firstInvalid.focus();
        }

        return;
    }

    const submitButton = form.querySelector('button[type="submit"]');
    if (submitButton) {
        submitButton.disabled = true;
        submitButton.textContent = 'Submitting...';
    }

    grecaptcha.ready(function () {
        grecaptcha.execute('6LfC6-4tAAAAAN_jz9ln87vRaN6dXGduLeluXwnU', { action: 'brochure' }).then(function (token) {
            const tokenField = form.querySelector('[name=RecaptchaToken]');
            if (tokenField) {
                tokenField.value = token;
            }
            form.submit();
        }).catch(function (err) {
            console.error('reCAPTCHA error:', err);
        });
    });
}

function pushDataLayer() {
    const errors = Array.from(form.elements)
        .filter(element => element.willValidate && !element.validity.valid)
        .map(element => ({
            message: element.validationMessage
        }));

    const dataLayerEvent = new FormSubmissionEvent(`brochure_${getBrochureDeliveryMethod()}`, errors, buildUser());
    dataLayerEvent.push();
}

function getBrochureDeliveryMethod() {
    return field('DeliveryMethod').value;
}

function buildUser() {
    const dataLayerUser = new DataLayerUser();

    dataLayerUser.name = new DataLayerUserName(value('Name'));
    dataLayerUser.email = value('Email');
    dataLayerUser.telephone = value('Phone');
    dataLayerUser.location = new DataLayerUserLocation(value('AddressLine1'), value('TownCity'), null, value('Postcode'));

    return dataLayerUser;
}

function value(name) {
    return field(name).value;
}

function field(name) {
    return form.querySelector(`[name=${name}]`);
}

function downloadBrochure() {
    const dataLayerEvent = new FileDownloadEvent('Digital Brochure', 'pdf', 'brochure', downloadBrochureLink.href);
    dataLayerEvent.push();
}